import React from 'react';

export class AgentAvatar extends React.Component {
   render() {
      return <div className='neo-icon-agents'></div>;
   }
};
